import { render, staticRenderFns } from "./RankGoods.vue?vue&type=template&id=b26e686c&scoped=true"
import script from "./RankGoods.vue?vue&type=script&lang=js"
export * from "./RankGoods.vue?vue&type=script&lang=js"
import style0 from "./RankGoods.vue?vue&type=style&index=0&id=b26e686c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26e686c",
  null
  
)

export default component.exports